import { render, staticRenderFns } from "./bulk-action-menu.vue?vue&type=template&id=7e228186&"
import script from "./bulk-action-menu.vue?vue&type=script&lang=js&"
export * from "./bulk-action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports